export const ContextPageType = {
  SMART_DATA_NEW_CLIENT: 'SMART_DATA_NEW_CLIENT',
  SMART_DATA_OLD_DATA: 'SMART_DATA_OLD_DATA',
  NO_SMART_DATA_NEW_CLIENT: 'NO_SMART_DATA_NEW_CLIENT',
  NO_SMART_DATA_OLD_DATA: 'NO_SMART_DATA_OLD_DATA',
};
